import styled from "styled-components";
//import backgroundImage from "../../assets/bgimage.webp";
import backgroundImage from "../../assets/roundBackground.png";
import theme from "../../theme";

const PageWrapper = styled.div`
  min-height: 100vh;
  // max-height: 100vh;
  display: flex;
  flex-direction: column;
  background: url(${backgroundImage}) no-repeat center center fixed;
  background-size: cover;
`;
const TopBar = styled.header`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 15px 30px 0px 30px;
  color: white;
  font-weight: bold;

  img {
    width: clamp(120px, 10vw, 160px);
    height: auto;
  }

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const MainContent = styled.main`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  padding: 0px 30px;

  @media (max-width: 1024px) {
    flex-direction: column;
  }

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const ImageWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 100%;
    height: auto;
  }
`;

const FormWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
`;

const Card = styled.div`
  background-color: white;
  border-radius: 1.5rem;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  padding: clamp(1.5rem, 3vw, 0.5rem);
  max-width: 450px;
`;

const HeaderContainer = styled.div`
  margin-bottom: 1rem;
`;

const Heading = styled.h1`
  font-size: clamp(1.5rem, 3vw, 2rem);
  font-weight: 700;
  color: #111827;
  margin-bottom: 0.5rem;
  font-family: "Inter", sans-serif;
`;

const SubText = styled.p`
  color: #4b5563;
  font-size: clamp(0.875rem, 2vw, 1rem);
  margin: 0;
  font-family: "Inter", sans-serif;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const InputWrapper = styled.div`
  width: 95%;
`;

const Label = styled.label`
  display: block;
  font-size: 0.875rem;
  color: #6b7280;
  margin-bottom: 0.5rem;
  font-family: "Inter", sans-serif;
`;

const InputField = styled.input`
  width: 100%;
  padding: 5px;
  border: 1px solid #e2e8f0;
  border-radius: 5px;
  font-size: 14px;
  font-family: "Inter", sans-serif;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: ${theme.colors.primary};
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }
`;

const CheckboxContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const CheckboxItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.75rem;
`;

const CheckboxText = styled.p`
  font-size: 12px;
  color: #6b7280;
  margin: 0;
  font-family: "Inter", sans-serif;
`;

const Button = styled.button`
  width: 100%;
  background-color: ${theme.colors.primary};
  color: white;
  font-weight: 600;
  padding: 8px;
  border-radius: 0.5rem;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 12px;
  font-family: "Inter", sans-serif;

  &:hover:not(:disabled) {
    background-color: ${theme.colors.buttonhover};
    transform: scale(1.02);
  }

  &:active:not(:disabled) {
    transform: scale(0.98);
  }

  &:disabled {
    background-color: #d1d5db;
    cursor: not-allowed;
    transform: none;
  }
`;

const Divider = styled.div`
  display: flex;
  align-items: center;
  margin: 1rem 0;
  color: #6b7280;
  font-size: 0.875rem;
  span {
    font-family: "Inter", sans-serif;
  }

  &::before,
  &::after {
    content: "";
    flex: 1;
    border-bottom: 1px solid #e5e7eb;
  }

  &::before {
    margin-right: 0.75em;
  }

  &::after {
    margin-left: 0.75em;
  }
`;

const AlternativeAction = styled.div`
  text-align: center;
  font-size: clamp(0.8rem, 2vw, 0.875rem);
  color: #6b7280;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.25rem;
  // margin-bottom: 20px;
  span {
    font-family: "Inter", sans-serif;
  }
`;

const AlternativeButton = styled.button`
  background: none;
  border: none;
  color: ${theme.colors.primary};
  font-weight: 500;
  cursor: pointer;
  padding: 0;
  transition: color 0.2s;
  font-family: "Inter", sans-serif;

  &:hover {
    color: ${theme.colors.primary};
    text-decoration: underline;
  }
`;

const SmallDivider = styled.div`
  width: 20%; // small width
  border-bottom: 1px solid #d1d5db; // light gray line
  margin: 0.5rem auto; // center horizontally and spacing
`;

const SC = {
  PageWrapper,
  TopBar,
  MainContent,
  ImageWrapper,
  FormWrapper,
  Card,
  HeaderContainer,
  Heading,
  SubText,
  Form,
  InputWrapper,
  Label,
  InputField,
  CheckboxContainer,
  CheckboxItem,
  CheckboxText,
  Button,
  Divider,
  AlternativeAction,
  AlternativeButton,
  SmallDivider,
};

export default SC;
